import Grid from '@material-ui/core/Grid'
import { useMount } from 'ahooks'
import DatePicker from 'Components/DatePicker'
import Search from 'Components/Search'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import React, { useState } from 'react'

export default React.memo(props => <Search limit={100} all raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
    path={'hotel'} requete={Constants.donnee.reservation} module={Constants.module.HOTEL}
    search={props.search || ((props.searchName || 'api_hotel_reservation_') + (props.name || '') + User.Entite.get().id)}>
    <SearchForm />
</Search>
)

const SearchForm = React.memo(props => {
    const [search, setSearch] = useState(props.search || {})
    const searching = (data, name) => {
        const srh = {
            ...(search || {}),
            [name]: data
        }
        setSearch(srh)
        props.searching && props.searching(srh)
    }

    useMount(() => {

    })

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
            alignItems={'stretch'}
            alignContent={'flex-start'}
            direction={'column'}>
            <DatePicker value={search['>=date_debut']}
                title={EurestoI18n.t('commun:Date de réservation')}
                onChange={searching}
                name={'>=date_debut'} />
            <DatePicker value={search['|date_modification']}
                range
                title={EurestoI18n.t('commun:Date de modification')}
                onChange={searching}
                name={'|date_modification'} />
        </Grid>
    )
})


// WEBPACK FOOTER //
// ./app/App/Module/Hotel/Component/Search/index.js